import { render, staticRenderFns } from "./ComponentInvoicePayments.vue?vue&type=template&id=e5370fc4"
import script from "./ComponentInvoicePayments.vue?vue&type=script&lang=js"
export * from "./ComponentInvoicePayments.vue?vue&type=script&lang=js"
import style0 from "./ComponentInvoicePayments.vue?vue&type=style&index=0&id=e5370fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports